function ConnectionService($auth, ApiService) {
  'ngInject';

  const service = {};
  service.connectAmazon = function (url,callbackFunc) {
    ApiService.get(url, callbackFunc);
  };

  service.postToAmazon = function (amazonForm, callbackFunc) {
    let data = {
      mws_marketplace_id: amazonForm.marketplaceId,
      mws_merchant_id: amazonForm.merchantId,
      aws_access_key_id: amazonForm.accessKey,
      aws_secret_access_key: amazonForm.secretKey,
      auth_token: amazonForm.authToken,
      api_v1_organization_id: amazonForm.org.id
    };
    ApiService.post(`/amazon_connections.json`, data, callbackFunc);
  };

  service.updateAmazonCon = function (amazonForm, conId, callbackFunc) {
    let data= {
      mws_marketplace_id: amazonForm.marketplaceId,
      mws_merchant_id: amazonForm.merchantId,
      aws_access_key_id: amazonForm.accessKey,
      aws_secret_access_key: amazonForm.secretKey,
      auth_token: amazonForm.authToken,
      api_v1_organization_id: amazonForm.org.id
    };
    ApiService.put(`/amazon_connections/${conId}.json`, data, callbackFunc);
  };

  service.editAmazonCon = function (conId,callbackFunc) {
    ApiService.get(`/amazon_connections/${conId}.json`, callbackFunc);
  };

  service.deleteAmazon = function (conId, callbackFunc) {
    ApiService.delete(`/amazon_connections/${conId}.json`, {}, callbackFunc);
  };

  let headers = $auth.retrieveData('auth_headers');
  service.xeroInfo = function(callbackFunc) {
    ApiService.get(`/xero/logged_xero_info.json`, callbackFunc);
  };


  service.disconnect = function(organization_id, callbackFunc) {
    ApiService.put(`/xero/disconnect/?&organization_id=${organization_id}`);
  };

  service.delete = function(organization_id, callbackFunc) {
    ApiService.delete(`/xero/destroy/?&organization_id=${organization_id}`, {}, callbackFunc);
  };

  service.refreshCache = function(organization_id, callbackFunc) {
    ApiService.get(`/xero/refresh_cache/?organization_id=${organization_id}`, callbackFunc);
  };

  service.fullRefresh = function(organization_id, callbackFunc) {
    ApiService.get(`/xero/full_refresh/?organization_id=${organization_id}`, callbackFunc);
  };

  // shopify connection
  service.connectShopify = function (url,callbackFunc) {
    ApiService.get(url, callbackFunc);
  };
 
  service.getXeroStatus = function (xeroId, callbackFunc) {
    ApiService.get(`/xero/${xeroId}/status.json`, callbackFunc);
  };

  service.getShopifyOauthConnections = function(url, callbackFunc){
    ApiService.get(url, callbackFunc);
  };

  service.deleteOauthShopify = function (conId, callbackFunc) {
    ApiService.delete(`/shopify_oauth_connections/${conId}.json`, {}, callbackFunc);
  };

  return service;
}

export default {
  name: 'ConnectionService',
  fn: ConnectionService
}
